import { useQuery } from "react-query";
import { getOfficeApplianceType } from "../api/officeApplianceService";

export const useGetOfficeApplianceType = () => {
  return useQuery("OfficeApplianceType", getOfficeApplianceType, {
    refetchOnWindowFocus: false,
  });
};
